module.exports = __webpack_public_path__ + "fonts/MullerExtraBoldItalic.dd825fea.ttf";